export default "__VITE_ASSET__498sx9tc__"